"use client";
import { jsx, jsxs } from 'react/jsx-runtime';
import { faCircleExclamation } from '@optimizely/pro-light-svg-icons';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import decorateQueryInText from '../../../utils/decorateQueryInText.js';
import { Icon } from '../../Icon/icon.js';
import { Typography } from '../../Typography/typography.js';

function DropdownBlockLinkSecondaryText(props) {
  const bold = useCallback(
    (string, key) => /* @__PURE__ */ jsx("span", { className: "weight--700", children: string }, key),
    []
  );
  const plain = useCallback(
    (string, key) => /* @__PURE__ */ jsx("span", { children: string }, key),
    []
  );
  const testSection = props.testSection ? "block-link-description-" + props.testSection : null;
  return /* @__PURE__ */ jsxs("div", { className: "oui-dropdown--descriptive__content flex", children: [
    props.isWarning && /* @__PURE__ */ jsx("div", { className: "flex flex-align--start push--right", children: /* @__PURE__ */ jsx(Icon, { icon: faCircleExclamation, size: "small" }) }),
    /* @__PURE__ */ jsx(
      Typography,
      {
        className: "truncate width--1-1",
        tag: "span",
        type: "xs",
        ...testSection ? { "data-test-section": testSection } : {},
        children: decorateQueryInText({
          decorateQuery: plain,
          decorateText: bold,
          query: props.searchQuery,
          text: props.secondaryText
        })
      }
    )
  ] });
}
DropdownBlockLinkSecondaryText.defaultProps = {
  isWarning: false,
  secondaryText: null
};
DropdownBlockLinkSecondaryText.propTypes = {
  /** should show info icon */
  isWarning: PropTypes.bool,
  /** If provided it'll match and highlight text based in current query */
  searchQuery: PropTypes.string,
  /** description text, if provided */
  secondaryText: PropTypes.node,
  /** test section from parent */
  testSection: PropTypes.string
};

export { DropdownBlockLinkSecondaryText as default };
